import { Platform } from 'react-native';
import { useAppStore } from '../store/useAppStore';
import '@/global.css';

export const LightColors = {
  primary: '#002D62', // Deep Blue
  accent: '#00C853', // Vibrant Emerald Green
  background: '#F5F7FA', // Light greyish background
  card: '#FFFFFF', // White cards
  text: '#1A1A1A', // Dark text
  textSecondary: '#60646C', // Gray text
  white: '#FFFFFF',
  error: '#FF3B30',
  border: '#E0E1E6',
  success: '#00C853',
  backgroundElement: '#EAECEF',
  backgroundSelected: '#DCDFE4',
};

export const DarkColors = {
  primary: '#00408C', // Slightly lighter blue for dark mode visibility
  accent: '#00E676', // Brighter green for dark mode
  background: '#121212', // Very dark background
  card: '#1E1E1E', // Dark cards
  text: '#FFFFFF', // White text
  textSecondary: '#A0A0A0', // Light gray text
  white: '#FFFFFF',
  error: '#FF453A',
  border: '#333333',
  success: '#00E676',
  backgroundElement: '#2A2A2A',
  backgroundSelected: '#3A3A3A',
};

export type ThemeColor = keyof typeof LightColors;

// Fallback static Colors for legacy files (will be removed as we refactor everything to useThemeColors)
export const Colors = LightColors;

export const useThemeColors = () => {
  const theme = useAppStore((state) => state.theme);
  return theme === 'dark' ? DarkColors : LightColors;
};

export const SIZES = {
  base: 8,
  small: 12,
  font: 14,
  medium: 16,
  large: 18,
  extraLarge: 24,
  padding: 20,
  radius: 16,
};

export const Fonts = Platform.select({
  ios: {
    sans: 'system-ui',
    serif: 'ui-serif',
    rounded: 'ui-rounded',
    mono: 'ui-monospace',
  },
  default: {
    sans: 'normal',
    serif: 'serif',
    rounded: 'normal',
    mono: 'monospace',
  },
  web: {
    sans: 'var(--font-display)',
    serif: 'var(--font-serif)',
    rounded: 'var(--font-rounded)',
    mono: 'var(--font-mono)',
  },
});

export const Spacing = {
  half: 2,
  one: 4,
  two: 8,
  three: 16,
  four: 24,
  five: 32,
  six: 64,
} as const;

export const BottomTabInset = Platform.select({ ios: 50, android: 80 }) ?? 0;
export const MaxContentWidth = 800;
